// SIP Calculation with Step-Up
export const calculateSIP = (
  monthlyInvestment: number,
  annualReturn: number,
  months: number,
  stepUpType?: string,
  stepUpValue?: number,
  stepUpFrequency?: number
): number => {
  const monthlyRate = annualReturn / (12 * 100);

  if (!stepUpType || stepUpType === 'none' || !stepUpValue) {
    return monthlyInvestment * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate);
  }

  let totalValue = 0;
  let currentInvestment = monthlyInvestment;
  const frequency = stepUpFrequency || 12;

  for (let month = 1; month <= months; month++) {
    totalValue = (totalValue + currentInvestment) * (1 + monthlyRate);

    if (month % frequency === 0) {
      if (stepUpType === 'percentage') {
        currentInvestment = currentInvestment * (1 + stepUpValue / 100);
      } else if (stepUpType === 'amount') {
        currentInvestment = currentInvestment + stepUpValue;
      }
    }
  }

  return totalValue;
};

// Lumpsum Calculation
export const calculateLumpsum = (investment: number, annualReturn: number, months: number): number => {
  const annualRate = annualReturn / 100;
  return investment * Math.pow(1 + annualRate, months / 12);
};

// SWP Calculation
export const calculateSWP = (
  initialInvestment: number,
  monthlyWithdrawal: number,
  annualReturn: number,
  months: number
): number => {
  const monthlyRate = annualReturn / (12 * 100);
  let remainingAmount = initialInvestment;

  for (let i = 0; i < months; i++) {
    remainingAmount = remainingAmount * (1 + monthlyRate) - monthlyWithdrawal;
    if (remainingAmount < 0) return 0;
  }

  return remainingAmount;
};

// Inflation Calculation
export const calculateInflation = (currentAmount: number, inflationRate: number, years: number): number => {
  return currentAmount * Math.pow(1 + inflationRate / 100, years);
};

// Retirement Corpus Calculation
export const calculateRetirementCorpus = (
  monthlyExpense: number,
  inflationRate: number,
  yearsToRetirement: number,
  postRetirementReturn: number,
  retirementYears?: number
): number => {
  const retirementDuration = retirementYears || 25;
  const futureMonthlyExpense = monthlyExpense * Math.pow(1 + inflationRate / 100, yearsToRetirement);
  const monthlyReturnRate = postRetirementReturn / (12 * 100);
  const totalMonths = retirementDuration * 12;

  return futureMonthlyExpense * ((1 - Math.pow(1 + monthlyReturnRate, -totalMonths)) / monthlyReturnRate);
};
